/* eslint-disable */
// @ts-nocheck 
import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  Grid,
  Button,
  Avatar,
  LinearProgress,
} from "@mui/material";
import { fonts, themes } from "../../../common/themes/themes";
import CustomAddActionCard from "../../../common/components/CustomAddActionCard/CustomAddActionCard";
import TaskBox from "../../../common/components/TaskBox/TaskBox";
import CreateBoardModalController from "../../../common/Modals/PerofomanceModals/CreateBoardModal/CreateBoardModalController";
import CreateTaskModalController from "../../../common/Modals/PerofomanceModals/CreateTaskModal/CreateTaskModalController";
import TaskDetailsModalController from "../../../common/Modals/PerofomanceModals/TaskDetailsModal/TaskDetailsModalController";

import { DndProvider, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
interface propsType {
  trans?: any;
  goalData?: any;
  handleCloseGoalDetailView?: any;
}
const GoalDetailViewPresenter: React.FC<propsType> = ({
  trans,
  goalData,
  handleCloseGoalDetailView,
}) => {
  const [showCreateBoard, setShowCreateBoard] = useState(false);
  const [showCreateTask, setShowCreateTask] = useState(false);
  const [showEditTask, setShowEditTask] = useState(false);
  const [openTaskDetail, setOpenTaskDetail] = useState(false);
  const handleCloseView = () => {
    handleCloseGoalDetailView(false);
  };

  const [tasks, setTasks] = useState<any>([
    { id: 1, title: "Login Portal", status: "To Do" },
    { id: 2, title: "Selected task", status: "Selected" },
    { id: 3, title: "In Progress task", status: "In-Progress" },
    { id: 4, title: "Task is completed", status: "Completed" },
    { id: 11, title: "Login Portal", status: "To Do" },
    { id: 12, title: "Selected task", status: "Selected" },
    { id: 13, title: "In Progress task", status: "In-Progress" },
    { id: 14, title: "Task is completed", status: "Completed" },
    { id: 21, title: "Login Portal", status: "To Do" },
    { id: 22, title: "Selected task", status: "Selected" },
    { id: 23, title: "In Progress task", status: "In-Progress" },
    { id: 24, title: "Task is completed", status: "Completed" },
    { id: 31, title: "Login Portal", status: "To Do" },
    { id: 32, title: "Selected task", status: "Selected" },
    { id: 33, title: "In Progress task", status: "In-Progress" },
    { id: 34, title: "Task is completed", status: "Completed" },

    { id: 41, title: "Login Portal", status: "To Do" },
    { id: 42, title: "Selected task", status: "Selected" },
    { id: 43, title: "In Progress task", status: "In-Progress" },
    { id: 44, title: "Task is completed", status: "Completed" },
    { id: 51, title: "Login Portal", status: "To Do" },
    { id: 52, title: "Selected task", status: "Selected" },
    { id: 53, title: "In Progress task", status: "In-Progress" },
    { id: 54, title: "Task is completed", status: "Completed" },
    { id: 61, title: "Login Portal", status: "To Do" },
    { id: 62, title: "Selected task", status: "Selected" },
    { id: 63, title: "In Progress task", status: "In-Progress" },
    { id: 64, title: "Task is completed", status: "Completed" },
    { id: 71, title: "Login Portal", status: "To Do" },
    { id: 72, title: "Selected task", status: "Selected" },
    { id: 73, title: "In Progress task", status: "In-Progress" },
    { id: 74, title: "Task is completed", status: "Completed" },

    { id: 81, title: "Login Portal", status: "To Do" },
    { id: 82, title: "Selected task", status: "Selected" },
    { id: 83, title: "In Progress task", status: "In-Progress" },
    { id: 84, title: "Task is completed", status: "Completed" },
    { id: 91, title: "Login Portal", status: "To Do" },
    { id: 92, title: "Selected task", status: "Selected" },
    { id: 93, title: "In Progress task", status: "In-Progress" },
    { id: 94, title: "Task is completed", status: "Completed" },
    { id: 111, title: "Login Portal", status: "To Do" },
    { id: 112, title: "Selected task", status: "Selected" },
    { id: 113, title: "In Progress task", status: "In-Progress" },
    { id: 114, title: "Task is completed", status: "Completed" },
    { id: 121, title: "Login Portal", status: "To Do" },
    { id: 122, title: "Selected task", status: "Selected" },
    { id: 123, title: "In Progress task", status: "In-Progress" },
    { id: 124, title: "Task is completed", status: "Completed" },
  ]);

  const moveTask = (id: number, newStatus: string) => {
    const updatedTasks = tasks.map((task: any) => {
      if (task.id === id) {
        console.log(id, "--id");

        return { ...task, status: newStatus };
      } else {
        console.log(id, "else --id");
      }

      return task;
    });
    setTasks(updatedTasks);
  };

  const renderColumn = (status: string, subTitile: string) => {
    const tasksInColumn = tasks.filter((task: any) => task.status === status);

    const handleDrop = (taskId: number, newStatus: string) => {
      if (taskId) {
        moveTask(taskId, newStatus);
      }
    };

    console.log("tasks--", tasks);

    return (
      <div>
        <CustomAddActionCard
          card_height="100%"
          card_title={status}
          card_subtitle={subTitile}
          showEditButton={true}
          onClick={() => setShowCreateTask(true)}
          onClickEdit={() => setShowEditTask(true)}
        >
          {tasksInColumn.map((task: any) => (
            <React.Fragment key={task.id}>
              <TaskBox
                key={task.id}
                id={task.id}
                title={task.title}
                status={task.status}
                onDrop={handleDrop}
                onClick={() => setOpenTaskDetail(true)}
              />
              <Box marginTop={"1em"} />
            </React.Fragment>
          ))}
          {tasksInColumn.length === 0 && (
            <EmptyDropTarget status={status} onDrop={handleDrop} />
          )}
        </CustomAddActionCard>
      </div>
    );
  };

  const EmptyDropTarget: React.FC<{
    status: string;
    onDrop: (id: number, newStatus: string) => void;
  }> = ({ status, onDrop }) => {
    const [, drop] = useDrop({
      accept: "TASK",
      hover: (item: any) => {
        if (item.status !== status) {
          onDrop(item.id, status);
          item.status = status; // Update the status to prevent continuous drops
        }
      },
    });
    return (
      <div
        ref={drop}
        style={{
          border: "1px dashed #ccc",
          borderRadius: "4px",
          marginBottom: "4px",
          minHeight: "50px",
        }}
      />
    );
  };
  return (
    <>
      <Box>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            sx={{
              marginTop: "1.75em",
              padding: "1em",
            }}
          >
            <Box
              sx={{
                height: "100%",
                width: "100%",
                background: "#FFFFFF 0% 0% no-repeat padding-box",
                borderRadius: "10px",
                opacity: "1",
                display: "flex",
                flexDirection: "row",
                padding: "0.5em",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i
                  className="las la-arrow-left"
                  style={{
                    color: "#BDBDBD",
                    width: "2em",
                    height: "1.5em",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                  onClick={handleCloseView}
                />
                <Typography
                  style={{
                    color: "#000000DE",
                    fontSize: "1em",
                    fontFamily: fonts.fontFamily,
                    marginLeft: "1em",
                    fontWeight: "bold",
                  }}
                >
                  Goal Details
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            sx={{
              padding: "1em",
            }}
          >
            <Box
              sx={{
                height: "100%",
                width: "100%",
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: "row",
              }}
            >
              <Box>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    color: "#000000",
                    fontSize: "0.825em",
                    fontWeight: "bold",
                  }}
                >
                  CB Mobile App
                </Typography>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    color: "#000000",
                    fontSize: "0.725em",
                    fontWeight: "bold",
                  }}
                >
                  <span style={{ color: "#9E9E9E" }}> Created:</span> 09/01/2023
                  | <span style={{ color: "#9E9E9E" }}>Due Date:</span>{" "}
                  09/02/2023
                </Typography>
              </Box>
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <Typography
                  style={{
                    color: "#000000",
                    fontSize: "1em",
                    fontWeight: "bold",
                  }}
                >
                  Assigned For
                </Typography>
                <Box style={{ marginLeft: "1em" }}>
                  <Avatar />
                </Box>
                <Button
                  style={{
                    backgroundColor: themes.primaryMain,
                    padding: "8px",
                    color: "white",
                    textTransform: "capitalize",
                    marginLeft: "1em",
                  }}
                  startIcon={<i className="las la-plus" />}
                  onClick={() => setShowCreateBoard(true)}
                >
                  Create Board
                </Button>
              </Box>
            </Box>
            <Box
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Typography
                style={{
                  color: "#000000",
                  fontSize: "0.7em",
                  fontFamily: fonts.fontFamily,
                }}
              >
                90 % Progress
              </Typography>

              <Box sx={{ flex: "1", marginX: "1em" }}>
                <LinearProgress
                  variant="determinate"
                  value={49}
                  sx={{
                    "&.MuiLinearProgress-root": {
                      backgroundColor: "#E6E8F0",
                    },
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: "#4CAF50",
                      boxShadow: "#00000029",
                    },
                  }}
                />
              </Box>

              <Typography
                style={{
                  color: themes.defaultError,
                  fontSize: "0.7em",
                  fontFamily: fonts.fontFamily,
                }}
              >
                3 Days Left
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Grid container spacing={2} style={{ marginTop: "0.5em" }}>
          <DndProvider backend={HTML5Backend}>
            <Grid item xs={3}>
              {renderColumn("To Do", "Total: 8")}
            </Grid>
            <Grid item xs={3}>
              {renderColumn("Selected", "Total: 8")}
            </Grid>
            <Grid item xs={3}>
              {renderColumn("In-Progress", "Total: 8")}
            </Grid>
            <Grid item xs={3}>
              {renderColumn("Completed", "Total: 8")}
            </Grid>
          </DndProvider>
        </Grid>
      </Box>
      {showCreateBoard && (
        <CreateBoardModalController
          closeModal={() => setShowCreateBoard(false)}
          isModalOpen={showCreateBoard}
          trans={trans}
        />
      )}
      {showCreateTask && (
        <CreateTaskModalController
          closeModal={() => setShowCreateTask(false)}
          isModalOpen={showCreateBoard}
          trans={trans}
        />
      )}
      {showEditTask && (
        <CreateTaskModalController
          closeModal={() => setShowEditTask(false)}
          isModalOpen={showCreateBoard}
          trans={trans}
        />
      )}
      {openTaskDetail && (
        <TaskDetailsModalController
          closeModal={() => setOpenTaskDetail(false)}
          isModalOpen={openTaskDetail}
          trans={trans}
        />
      )}
    </>
  );
};

export default GoalDetailViewPresenter;
